import {
  ChannelType,
  ImageType,
  LineType,
} from '@/types/servicesTypes/configTypes'
import { SectionGridGroupType, TabType } from '@/types/servicesTypes/pageTypes'

export const enum MenuAppConfigKey {
  SPECIAL_HOME = 'specialHome',
  HOME = 'home',
  SELECTED = 'selected',
}

export type MenuItemType = {
  isFavorite?: boolean
  id: string
  name?: string
  shortTitle?: string
  icon?: ImageType
  path?: string
  appConfigKey?: MenuAppConfigKey
  iconDirectPath?: string
  hasSubmenu?: boolean
  hidden?: boolean
  pageType?: string
  title?: string
  logo?: ImageType
  tabs?: Array<TabType>
  backgroundImage?: ImageType
  grid?: { gridContextID: string }
  lines?: LineType[]
  sectionGrid?: SectionGridGroupType
  landing?: { sectionGrid?: SectionGridGroupType }
  classicHome?: { channels?: ChannelType[]; lines?: LineType[] }
}
